import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatPrice, formatDate } from "@/lib/api";
import { Package, ShoppingCart, Clock } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then(({ data }) => setStats(data));
  }, []);

  const cards = [
    { label: "Total Products", value: stats?.total_products, icon: Package, color: "text-brand" },
    { label: "Total Orders", value: stats?.total_orders, icon: ShoppingCart, color: "text-brand-green" },
    { label: "Pending Orders", value: stats?.pending_orders, icon: Clock, color: "text-brand-gold" },
  ];

  return (
    <div>
      <h1 className="font-heading text-3xl text-brand-dark">Dashboard</h1>
      <p className="text-brand-muted">Overview of your store</p>

      <div className="mt-6 grid gap-5 sm:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} data-testid={`stat-${c.label.toLowerCase().replace(/ /g, "-")}`} className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
            <div className="flex items-center justify-between">
              <p className="text-sm text-gray-500">{c.label}</p>
              <c.icon className={`h-5 w-5 ${c.color}`} />
            </div>
            <p className="mt-2 font-heading text-4xl text-brand-dark">{c.value ?? "—"}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <h2 className="font-heading text-2xl text-brand-dark">Recent Orders</h2>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-gray-200 text-gray-500">
                <th className="pb-3">Order ID</th>
                <th className="pb-3">Date</th>
                <th className="pb-3">Customer</th>
                <th className="pb-3">Total</th>
                <th className="pb-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {(stats?.recent_orders || []).map((o) => (
                <tr key={o.order_id} className="border-b border-gray-100">
                  <td className="py-3 font-medium text-brand">
                    <Link to="/admin/orders" className="hover:underline">{o.order_id}</Link>
                  </td>
                  <td className="whitespace-nowrap py-3 text-gray-600">{formatDate(o.created_at)}</td>
                  <td className="py-3">{o.customer?.name}</td>
                  <td className="py-3">{formatPrice(o.total)}</td>
                  <td className="py-3">
                    <span className="rounded-full bg-brand-green/10 px-3 py-1 text-xs font-medium text-brand-green">{o.status}</span>
                  </td>
                </tr>
              ))}
              {stats && stats.recent_orders.length === 0 && (
                <tr>
                  <td colSpan={5} className="py-6 text-center text-gray-400">No orders yet</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
